import _ from 'lodash'
import * as graph from '@adc/sdk'

export const getProductType = listing =>
  _.get(listing, 'listing_configuration.product_type', '')

export const getAssetType = listing =>
  _.get(listing, 'listing_configuration.asset_type', '')

const getTrusteeSale = listing => _.get(listing, 'event.trustee_sale', false)

const getVenueType = listing => _.get(listing, 'venue.venue_type', '')

const getPartyMemberByRole = (listing, role) =>
  listing.parties?.find(party => party.party_role === role)

/**
 * Checking both because it seems that trustee_sales_channel is not filled in for
 * TPS online (e.g. Ohio) but cried_by is.
 */
export const hasADCAuctioneer = listing =>
  _.get(listing, 'listing_configuration.trustee_sales_channel') ===
    'AUCTIONEERING' ||
  _.get(listing, 'listing_configuration.cried_by') === 'AUCTIONEERING'

export const isLive = listing =>
  getVenueType(listing) === graph.enums.VenueType.Live

export const isTPS = listing => getTrusteeSale(listing)

export const isREO = listing => !getTrusteeSale(listing)

export const isTPSLive = listing => isTPS(listing) && isLive(listing)

export const isTPSOnline = listing =>
  isTPS(listing) && listing?.auction?.is_online && hasADCAuctioneer(listing)

export const isShortSale = listing =>
  getProductType(listing) === graph.enums.ProductType.ShortSale

export const isPrivateSeller = listing =>
  getAssetType(listing) === graph.enums.AssetType.PrivateSeller

export const isFCLMarketing = listing =>
  getProductType(listing) === graph.enums.ProductType.FclMarketing

export const getBrokerAgent = listing =>
  getPartyMemberByRole(listing, graph.enums.ListingPartyRole.ListingAgent)

export const getForeclosureContact = listing =>
  getPartyMemberByRole(
    listing,
    graph.enums.ListingPartyRole.ForeclosureAttorneyContact
  )

export const hasMarketingTag = (listing, name) => {
  return listing.marketing_tags?.find(listingTag => listingTag.tag === name)
}

/**
 * This is also in card helpers but that one is causing a circular dependency
 */
export const isForeclosure = listing =>
  listing.listing_configuration?.asset_type ===
  graph.enums.AssetType.Foreclosure
